import { Notyf }            from    'notyf';
import FormResources        from './form_resources';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {

    data(){
        return{
            notyf,
        }
    },

    methods: 
    {
        async form_submit(flag)
        {
            let associates_selected = this.$refs.advanced_search.returnedAssociatesToParent()

            if(!associates_selected.checked_items.length)
            {
                notyf.error('No associates selected')
                return false
            }

            if(!flag)
            {
                window.$('#confirmation-fields-modal').modal('show')
                return false
            }
            else if(flag)
            {
                window.$('#confirmation-fields-modal').modal('hide')
            }

            associates_selected.checked_items = associates_selected.checked_items.map(item => item.id)
            associates_selected.unchecked_items = associates_selected.unchecked_items.map(item => item.id)

            this.loader(true)


            const response = await this.post(`${this.rest_api}_mass_edit`, {...this.form_data, ...associates_selected})

            if(response.status)
            {
                notyf.success('Success')
                this.loader()
                this.form_data = {...this.form_backup}
                this.summary = response.data.summary

                if(this.summary.length)
                {
                    window.$('#summary-mass-edit').modal('show')
                }

                this.$refs.advanced_search.resetList()

            }
            else
            {
                this.loader()
                notyf.error('Error')
                this.error_handling(response)
            }
        },

        getInitialData(data)
        {
            this.array_options = {
                role_id:                data.roles,
                permissions_template_id: data.permissions_templates,
                reports_to:             data.report_to_associates,
                country_id:             data.countries,
                position_id:            data.positions,
                shift_id:               FormResources.shifts,
                department_id:          data.departments,
                contact_type_id:        data.contact_types,
                status_id:              FormResources.statuses
            }
        },

        async searchReportsTo(val)
        {
            this.loader(true)

            this.form_data.reports_to = ''

            this.array_options.reports_to = []
                    
            const response = await this.post('reports_to_by_roles', {rol: val, id: null})

            if(response.status)
            {
                this.array_options.reports_to = response.data.associates
            }

            this.loader()
        }
    },

    watch: 
    {
        async 'form_data.role_id' (val)
        {
            if(val)
            {
                this.searchReportsTo(val)
            }
            else
            {
                this.searchReportsTo(4)
            }
        },

    },

    mounted()
    {
        this.searchReportsTo(4)
    }
}

export default Methods